import './home.css'
import wwwwoohooo from './assets/home/wwwwoohooo.png'

import rankytanktitle from './assets/home/husholdtitle.png'

import rankytanklogo from './assets/home/husholdlogolarge2.png'

import wwwappstore15pct from './assets/home/wwwappstore15pct.png'
import wwwgoogleplay15pct from './assets/home/wwwgoogleplay15pct.png'
import privacybutton from './assets/home/privacybutton.png'
import supportbutton from './assets/home/supportbutton.png'
import serpapibutton from './assets/home/serpapibutton.png'

import workinprogress from './assets/home/workinprogress2.png'

import Footer from './footer'

function HusHold() {
  return (
    <div className="page">
      <div className="main_page">
        <a href="/">
          <img className="woohooologo" src={wwwwoohooo} />
        </a>
      </div>

      <div className="main_page" style={{ paddingBottom: 10, display: 'flex' }}>
        <div
          className="rankytank"
          style={{
            position: 'relative',
            flex: 1,
            marginTop: '1vw',
            display: 'flex',
            flexDirection: 'column', // 👈 vigtigt!
            alignItems: 'center', // 👈 centrer vandret
            justifyContent: 'center', // 👈 centrer lodret
          }}
        >
          <img className="husholdtitle2" src={rankytanktitle} />
          <div
            className="rankytanksubtitle"
            style={{
              position: 'relative',
              marginTop: '1vw',
              maxWidth: '70%',
              alignSelf: 'center',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ..danish app, to organize shopping lists etc — because running out of toilet paper is never fun.
          </div>
          <img className="rankytanklogo" src={rankytanklogo} />
          <div>
            <div style={{ position: 'relative', display: 'inline-block' }}>
              <div className="rankytankapplestore">
                <a href="https://apps.apple.com/dk/app/hushold/id6745343241">
                  <img src={wwwappstore15pct} />
                </a>
              </div>
              <div className="rankytankgoogleplay">
                <a href="https://play.google.com/store/apps/details?id=com.woohooo.hushold">
                  <img src={wwwgoogleplay15pct} />
                </a>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ display: 'flex', gap: 5, flexDirection: 'column' }}>
                <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', justifyContent: 'center' }}>
                  <div style={{}}>
                    <a href="/husholdprivacy">
                      <img src={privacybutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/husholdsupport">
                      <img src={supportbutton} />
                    </a>
                  </div>
                  <div style={{}}>
                    <a href="/husholdserpapi">
                      <img src={serpapibutton} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default HusHold
